export function glsl(texts: TemplateStringsArray) {
  return texts.join("").trim();
}
